import { v4 as uuidv4 } from 'uuid'
import { operationsAjax } from '../ajax/OperationsAjax'
import { store } from '../state/store'
import { computeShiftId } from './computeShiftId'
import { enqueue } from './queueOps'
import { provisionalPlantId } from './provisionalOperations'
import { isOnlineNow } from './connectivity'
import { mayQueueOffline, offlineRefusal } from './offlineWrites'
import { sendDirect } from './directSave'

function currentShiftId(): number {
  const { selectedDate, selectedShift } = store.getState().shift
  return computeShiftId(selectedDate, selectedShift)
}

export const operationLocationMutations = {
  async updateOperationLocation(operationId: number, locationId: number) {
    const clientId = uuidv4()
    if (isOnlineNow()) {
      const sent = await sendDirect(() => operationsAjax.updateOperationLocation(operationId, locationId, clientId))
      if (sent) return sent
    }
    if (!mayQueueOffline()) return offlineRefusal()
    await enqueue({
      clientId,
      entity: 'operationLocation',
      operation: 'update',
      shiftId: currentShiftId(),
      entityId: operationId,
      data: { operationId, locationId, operationPlantId: provisionalPlantId(operationId) },
    })
    return { success: true, data: null }
  },
}
